import { OutlineSection } from '../components/user-dashboard/blog/partials/article-outline/article-outline.component';
import { MediaLibraryFileModel } from './sales-funnel';
export class BlogPostItem {
  id: number;
  title: string;
  description: string;
  status: BlogItemStatusEnum;
  content: OutlineSection[];

  previewUrl: string;

  meta: {
    categories?: { id?: number; name?: string }[];
    seo?: { title?: string; description?: string; keywords?: string[] };
    readTime?: string;
    author?: any;
  };
  public url: string;
  image: MediaLibraryFileModel[];
  imageId: number[];
  createdAt: number;
  updatedAt: number;
}

export enum BlogItemStatusEnum {
  published = 'published',
  draft = 'draft',
}

export class CreateOrUpdateBlogPostDTO {
  title: string;
  status?: BlogItemStatusEnum;
  content?: OutlineSection[];
  // categoriesId?: number[];
  meta: {
    categories?: string[];
    seo?: { title?: string; description?: string; keywords?: string[] };
    readTime?: string;
    author?: any;
  };
  imageId?: number | number[];
}

export enum SubWizardStepEnum {
  title = 'title',
  subtitle = 'subtitle',
  description = 'description',
}
